import { createSlice } from '@reduxjs/toolkit';
import { setIsLoading } from '../isLoading.slice';
import axios from 'axios';
import { logOut } from '../../../resources/utils';


export const documentsSlice = createSlice({
    name: 'documents',
    initialState: {
        items: [],
        item: {},
        message: "",
        error: "",
    },
    reducers: {
        initialStateDocument: (state, action) => {
            return {
                items: [],
                item: {},
                message: "",
                error: "",
            }
        },
        setDocuments: (state, action) => {
            return {
                items: action.payload,
                item: {},
                message: "",
                error: "",
            }
        },
        setDocument: (state, action) => {
            return {
                items: [],
                item: action.payload,
                message: "",
                error: "",
            }
        },
        setDocumentMessages: (state, action) => {
            return {
                items: [],
                item: {},
                message: action.payload,
                error: "",
            }
        },
        setDocumentError: (state, action) => {
            return {
                items: [],
                item: {},
                message: "",
                error: action.payload,
            }
        },
    }
})

export const getDocumentsThunk = () => dispatch => {
    dispatch(setIsLoading(true));
    axios.get(`/documents`)
        .then(res => {
            if (res.status === 200) {
                dispatch(setDocuments(res.data))
            }
        })
        .catch(res => {
            if (res.response.status === 498) {
                logOut();
            } else {
                dispatch(setDocumentError(res.response?.data))
            }
        })
        .finally(() => dispatch(setIsLoading(false)))
};

export const getDocumentThunk = (document_id) => dispatch => {
    dispatch(setIsLoading(true));
    axios.get(`/documents/${document_id}`)
        .then(res => {
            if (res.status === 200) {
                dispatch(setDocument(res.data))
            }
        })
        .catch(res => {
            if (res.response.status === 498) {
                logOut();
            } else {
                dispatch(setDocumentError(res.response?.data))
            }
        })
        .finally(() => dispatch(setIsLoading(false)))
};


export const createDocumentThunk = (data) => dispatch => {
    dispatch(setIsLoading(true));
    axios.post(`/documents/createDocument`, data)
        .then(res => {
            if (res.status === 200) {
                dispatch(setDocumentMessages(res.data.data))
            }
        })
        .catch(res => {
            if (res.response.status === 498) {
                logOut();
            } else {
                dispatch(setDocumentError(res.response?.data))
            }
        })
        .finally(() => dispatch(setIsLoading(false)))
};


export const updateDocumentThunk = (document_id, data) => dispatch => {
    dispatch(setIsLoading(true));
    axios.put(`/documents/updateDocument/${document_id}`, data)
        .then(res => {
            if (res.status === 200) {
                dispatch(setDocumentMessages(res.data.data))
            }
        })
        .catch(res => {
            if (res.response.status === 498) {
                logOut();
            } else {
                dispatch(setDocumentError(res.response?.data))
            }
        })
        .finally(() => dispatch(setIsLoading(false)))
};


export const deleteDocumentThunk = (document_id) => dispatch => {
    dispatch(setIsLoading(true));
    axios.delete(`/documents/${document_id}`)
        .then(res => {
            if (res.status === 200) {
                dispatch(setDocumentMessages(res.data.data))
            }
        })
        .catch(res => {
            if (res.response.status === 498) {
                logOut();
            } else {
                dispatch(setDocumentError(res.response?.data))
            }
        })
        .finally(() => dispatch(setIsLoading(false)))
};


export const { 
    initialStateDocument,
    setDocuments,
    setDocument,
    setDocumentMessages,
    setDocumentError
} = documentsSlice.actions;

export default documentsSlice.reducer;